// extracted by mini-css-extract-plugin
module.exports = {"tagCertificate":"styles_tagCertificate__2EVRp","noDownload":"styles_noDownload__3nW8o","tagTitle":"styles_tagTitle__2pkRV"};